/**
 * Identifiers in this list have negative z-indices and are in ascending order.
 */
const BACK_Z_INDICES = [
  'TABLE_CELL_BACKGROUND',
  'PARAGRAPH_BACKGROUND',
  'TEXT_HIGHLIGHT',
  'TABLE_CELL_SELECTION_HIGHLIGHT',
] as const;

/**
 * Identifiers in this list have positive z-indices and are in ascending order.
 */
const FRONT_Z_INDICES = ['DYNAMIC_BLOCK_BAR'] as const;

type BackZIndexKey = (typeof BACK_Z_INDICES)[number];
type FrontZIndexKey = (typeof FRONT_Z_INDICES)[number];
type CanvasZIndexKey = BackZIndexKey | FrontZIndexKey;

/**
 * An object mapping each identifier defined in BACK_Z_INDICES or FRONT_Z_INDICES to its unique
 * z-index.
 */
export const CANVAS_Z_INDICES = {} as Record<CanvasZIndexKey, number>;

for (let index = 0; index < BACK_Z_INDICES.length; index++) {
  const key = BACK_Z_INDICES[index];
  CANVAS_Z_INDICES[key] = index - BACK_Z_INDICES.length;
}

for (let index = 0; index < FRONT_Z_INDICES.length; index++) {
  const key = FRONT_Z_INDICES[index];
  CANVAS_Z_INDICES[key] = index + 1;
}
